import React, { forwardRef } from 'react';
import classNames from 'classnames';
import { Box } from '@fiverr-private/theme';
import { ListProps } from '../List/types';
import { generateDefaultPadding } from '../List/helpers';

const UnorderedList = forwardRef<HTMLElement, ListProps>(({ children, className, ...restProps }: ListProps, ref) => (
  <Box
    ref={ref}
    as="ul"
    listStyleType="initial"
    display="flex"
    direction="column"
    className={classNames(generateDefaultPadding(restProps), className)}
    {...restProps}
  >
    {children}
  </Box>
));

UnorderedList.displayName = 'UnorderedList';

export default UnorderedList;
